export const environment = {
  production: true,
  envName: 'apex',
  apiUrl: 'https://ruby-rest.apex.nhs.uk/',
  onboardingCookie: "ApexRuby_OnboardingDismissed",
  onboardingStepsPath: "assets/json/OnBoarding/steps.json"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts